'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Soc2(eyebrow, title, lead, body, tags, noticeLead, notice, pathTitle, pathHint, path, link) {
  this.hQ = null;
  this.hZ = null;
  this.hR = null;
  this.hP = null;
  this.hY = null;
  this.hU = null;
  this.hT = null;
  this.hX = null;
  this.hW = null;
  this.hV = null;
  this.hS = null;
  this.hQ = eyebrow;
  this.hZ = title;
  this.hR = lead;
  this.hP = body;
  this.hY = tags;
  this.hU = noticeLead;
  this.hT = notice;
  this.hX = pathTitle;
  this.hW = pathHint;
  this.hV = path;
  this.hS = link;
}
export { $c_Lio_intela_sites_intelacloud_content_Soc2 as $c_Lio_intela_sites_intelacloud_content_Soc2 };
$p = $c_Lio_intela_sites_intelacloud_content_Soc2.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Soc2;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Soc2() {
}
export { $h_Lio_intela_sites_intelacloud_content_Soc2 as $h_Lio_intela_sites_intelacloud_content_Soc2 };
$h_Lio_intela_sites_intelacloud_content_Soc2.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 735353306, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Soc2)) {
    if ((this.hQ === x$0.hQ)) {
      var x = this.hZ;
      var x$2 = x$0.hZ;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if ((($x_3 && (this.hR === x$0.hR)) && (this.hP === x$0.hP))) {
      var x$3 = this.hY;
      var x$4 = x$0.hY;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ((((($x_2 && (this.hU === x$0.hU)) && (this.hT === x$0.hT)) && (this.hX === x$0.hX)) && (this.hW === x$0.hW))) {
      var x$5 = this.hV;
      var x$6 = x$0.hV;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.hS;
      var x$8 = x$0.hS;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 11;
});
$p.I = (function() {
  return "Soc2";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.hQ;
      break;
    }
    case 1: {
      return this.hZ;
      break;
    }
    case 2: {
      return this.hR;
      break;
    }
    case 3: {
      return this.hP;
      break;
    }
    case 4: {
      return this.hY;
      break;
    }
    case 5: {
      return this.hU;
      break;
    }
    case 6: {
      return this.hT;
      break;
    }
    case 7: {
      return this.hX;
      break;
    }
    case 8: {
      return this.hW;
      break;
    }
    case 9: {
      return this.hV;
      break;
    }
    case 10: {
      return this.hS;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Soc2(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bF)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Soc2 as $isArrayOf_Lio_intela_sites_intelacloud_content_Soc2 };
var $d_Lio_intela_sites_intelacloud_content_Soc2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Soc2, "io.intela.sites.intelacloud.content.Soc2", ({
  bF: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Soc2 as $d_Lio_intela_sites_intelacloud_content_Soc2 };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Soc2.js.map
